// Studio UI prefs. Tiny zustand store with localStorage persistence —
// matches the pattern in app/src/stores/ui.ts.

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UiState {
  railCollapsed: boolean;
  toggleRail: () => void;
  setRail: (collapsed: boolean) => void;
}

export const useUi = create<UiState>()(
  persist(
    (set) => ({
      railCollapsed: false,
      toggleRail: () => set((s) => ({ railCollapsed: !s.railCollapsed })),
      setRail: (collapsed) => set({ railCollapsed: collapsed }),
    }),
    { name: 'disha.studio.ui' },
  ),
);
